import { Route } from "@angular/router";
import { Permissions } from "src/app/core/common";
import { RoutesConstants } from "src/app/shared/common";
import { PermissionGuard } from "src/app/shared/guard/permission-guard";

export const ADD_NEW_TEACHER: Route[] = [
    {
        path: RoutesConstants.ADD_NEW_TEACHER_PAGE_URL,
        canActivate: [PermissionGuard],
        loadComponent: () => import('./pages/add-new-teacher-page/add-new-teacher-page.component').then(x => x.AddNewTeacherPageComponent),
        data: {
            breadcrumb: {
                label: 'ADD_NEW_TEACHER',
                icon: 'person_add'
            },
            permissions: [Permissions.HomePage_AddTeacher]
        }
    }
]